import { useLayoutEffect, useState } from "react";

const INSET = '[data-slot="sidebar-inset"]';

/**
 * The app content's left edge in viewport px (the app sidebar's right edge),
 * so an expanded Casey panel fills the page beside the sidebar instead of
 * covering it. 0 when the inset isn't mounted or the sidebar is off-canvas.
 */
export function useSidebarInsetLeft(enabled = true): number {
  const [left, setLeft] = useState(0);
  useLayoutEffect(() => {
    if (!enabled) return undefined;
    const inset = document.querySelector<HTMLElement>(INSET);
    if (!inset) return undefined;
    const measure = () =>
      setLeft(Math.max(0, Math.round(inset.getBoundingClientRect().left)));
    measure();
    window.addEventListener("resize", measure);
    const ro =
      typeof ResizeObserver === "undefined"
        ? null
        : new ResizeObserver(measure);
    ro?.observe(inset);
    // The sidebar collapsing slides the inset without resizing its parent.
    if (inset.parentElement) ro?.observe(inset.parentElement);
    return () => {
      window.removeEventListener("resize", measure);
      ro?.disconnect();
    };
  }, [enabled]);
  return left;
}
